/** Indian grouping — 1,00,000. Used for every quantity and amount on screen. */
export const fmtNum = (v, fallback = "—") => {
  if (v === null || v === undefined || v === "") return fallback;
  const n = Number(v);
  if (Number.isNaN(n)) return fallback;
  return n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

/** Money with two decimals — 1,00,000.00 */
export const fmtAmount = (v, fallback = "—") => {
  if (v === null || v === undefined || v === "") return fallback;
  const n = Number(v);
  if (Number.isNaN(n)) return fallback;
  return n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/** The one money format in this app — ₹1,23,456.00 */
export const fmtMoney = (v, fallback = "—") => {
  const s = fmtAmount(v, null);
  return s === null ? fallback : `₹${s}`;
};
